(function() {
	'use strict';

	/**
	 * Service for managing the User. (auth, database)
	 * @TODO try to get fullySync plugin to work
	 */

	angular
		.module("pwc.pouch.user")
		.service("userPouch", userPouch);

	userPouch.$inject = ['$window', '$rootScope', '$mdToast', 'pouchDB', 'lodash', '$log', '$q', 'systemPouch', 'ENV', 'Rollbar', 'Utils', 'LocalUsers'];

	function userPouch($window, $rootScope, $mdToast, pouchDB, lodash, $log, $q, systemPouch, ENV, Rollbar, Utils, LocalUsers){

		/* jshint validthis: true */
		var self = this;

		self.apiURL = ENV.COUCH_URL;

		self.remote = null;

		// this is the user's actual data in a local pouch db
		self.db = null;

		// local to remote pouch sync handler
		self.syncHandler = {};

		self.syncPercentage = 0;

		self.hasSyncToast = null;

        initialize();

		/**
		 * Constructor / Initialization
		 */

		function initialize(){
			$log.debug('userPouch initialized.');
		}

		/**
		 * Bootstraps user db if user exists.
		 */
		function bootstrap(){

			$log.debug('userPouch:bootstrap');

			return LocalUsers.activeUserName()
				.then(function(userName){
					return initializeUserDbFor(userName).then(startReplication);
				})
				.catch(function(err){
					$log.error('Error bootstrapping!', err);
				});
		}

		/**
		 * This ensures we have an active user and bootstraps the db.
		 * @returns {*}
		 */
		function assertActiveUserAndBootstrap(){

            $log.debug('userPouch:assertActiveUserAndBootstrap');

			return assertActiveUser()
				.then(function(userName){
					return initializeUserDbFor(userName);
				})
				.then(startReplication)
				.catch(function(err){
					$log.error('Error bootstrapping!', err);
                    redirectToLogin();
				});
		}

		/**
		 * Begin methods
		 */

		function getRemoteDatabase(){
			return self.remote;
		}

		function getLocalDatabase(){
			return self.db;
		}

		function getSyncHandler(){
			return self.syncHandler;
		}

		function onDenied(info){
			$log.debug('Sync denied', info);
		}

		function onError(err) {
			$log.debug('User db error', err);
		}

		function onComplete(){
			$log.debug('Sync was canceled.');
		}

		function onPaused(info){
			// this actually means the sync was completed because we're doing live replication - so on complete doesn't fire
			$log.debug('User db replication on pause/completed.');
		}

		function onActive(info){
			$log.debug('User db replication resumed.');
		}

		function save(record, cb){

			if (isEmptyOrNull(record['_id'])){
				record.created = $window.moment().toISOString();

				record['_id'] = record.generateId();
			}

			// enforce int
			lodash.set(record, 'cellar.qty', lodash.parseInt(lodash.get(record, 'cellar.qty', 0)));

			// enforce float
			lodash.set(record, 'cellar.value', parseFloat(lodash.get(record, 'cellar.value', 0.00)));

			record.updated = $window.moment().toISOString();

			// ensure qty & values are correct
			// @TODO trigger event instead?
			record.updateCellar();

			return self.db.put(angular.fromJson(angular.toJson(record))).then(function(){
				$rootScope.$emit('WineRecordWasChanged');
			});
		}

		function isEmptyOrNull(val){
			return ! angular.isDefined(val) || val === '' || lodash.isNull(val);
		}

		function remove(record, cb){

			if (! lodash.isEmpty(record['_id'])){
				self.db.remove(angular.fromJson(angular.toJson(record)), cb);
			}

			return false;
		}

        /**
         * @param userName
		 * @return Promise
         */
		function initializeUserDbFor(userName){
			// on Safari, we need to make a big ask up-front for 500M
			// Sadly, iOS is limited to 50
			var size = Utils.agent.isIOS() ? 50 : 500;

			// initialize the local user pouch

			var opts = {
				size: size,
				"auto_compaction": true
			};

            $log.debug('Initializing active user db for ' + userName, opts);

			var dbName = userName.replace(/ /g, '-');

			self.db = pouchDB('pwc_db_' + dbName, opts);

			return $q.when(userName);
		}

		function createCustomFieldIndex(){

			var customFieldsDesignDoc = {
				_id: '_design/custom_field_index',
				views: {
					'custom_field_index': {
						map: function(doc) {
							if (doc.custom && doc.custom.length > 0){
								doc.custom.forEach(function(item){
									emit(item.label, item.value);
								});
							}
						}.toString()
					}
				}
			};

			return self.db.put(customFieldsDesignDoc).then(function() {
				$log.debug('customFieldsDesignDoc created');
				// kick off an initial build, return immediately
				return self.db.query('custom_field_index', {stale: 'update_after'});
			}).catch(function(err){
				$log.info('customFieldsDesignDoc already exists', err);
			});

		}

		function setupUserRemote(userName){
			$log.debug('Setting up user remote for:', userName);
            // To prevent browser HTTP basic authentication modal dialogs of ye olde times, we have to be subtle in the way we use PouchDB.
            // To prevent a rogue unauthenticated request to CouchDB (used to check whether the remote DB exists), pass skipSetup: true.
            self.remote = pouchDB(self.apiURL + '/userdb-' + bin2hex(userName), {
                skip_setup: true,
                skipSetup: true,
                ajax: {
                    timeout: 120000
                }
            });
		}

		function login(userName, password){

            $log.debug('Attempting login...');

			setupUserRemote(userName);

			var ajaxOpts = {
				ajax: {
					headers: {
						Authorization: 'Basic ' + window.btoa(userName + ':' + password)
					}
				}
			};

			return self.remote.login(userName, password, ajaxOpts)
					.then(function(response){
						return self.remote.getUser(response.name);
					})
					.then(function(response){
                        $log.debug('Got User From Remote: ', response);

						return initializeUserDbFor(response.name)
                            .then(function(userName){
                                return LocalUsers.findByName(userName);
                            })
                            .then(function(doc){
                                var userDataFromRemote = lodash.pick(response, [
                                    'derived_key',
                                    'metadata'
                                ]);

                                var newUserDoc = lodash.merge(doc, userDataFromRemote);

                                $log.debug('Updating user in LocalUsers:', newUserDoc);

                                // update local user info from remote
                                return LocalUsers.addUser(newUserDoc);
                            }).catch(function(err){
                            	// user does not exist in LocalUsers, need to add

								$log.warn('User does not exist in LocalUsers', err.message);

                                var userDataFromRemote = lodash.omit(response, [
                                    'password',
									'_rev',
									'iterations',
									'password_scheme',
									'roles',
									'salt',
									'type'
                                ]);

                                $log.debug('Adding user to LocalUsers:', userDataFromRemote);

                                // update local user info from remote
                                return LocalUsers.addUser(userDataFromRemote);

							});
					})
					.then(function(user){
						$log.debug('userPouch:login', user);
						// update the active user
						return LocalUsers.setActiveUser(userName);
					});
		}

		// @todo move to helper / library file
		function bin2hex(s) {
			//  discuss at: http://phpjs.org/functions/bin2hex/
			// original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// bugfixed by: Onno Marsman
			// bugfixed by: Linuxworld
			// improved by: ntoniazzi (http://phpjs.org/functions/bin2hex:361#comment_177616)
			//   example 1: bin2hex('Kev');
			//   returns 1: '4b6576'
			//   example 2: bin2hex(String.fromCharCode(0x00));
			//   returns 2: '00'

			var i, l, o = '',
				n;

			s += '';

			for (i = 0, l = s.length; i < l; i++) {
				n = s.charCodeAt(i)
					.toString(16);
				o += n.length < 2 ? '0' + n : n;
			}

			return o;
		}

		function startReplication(userName){

			if (! lodash.isEmpty(self.syncHandler)){
				$log.debug('Sync handler for user already active.');
				return false;
			}

			$log.debug('Attempting to start replication for user db', userName);

			setupUserRemote(userName);

			// verify we have a valid session

			return self.remote.getSession()
				.then(function(){
					if (! LocalUsers.getDatabase() || ! self.db){
						$log.warn('Cannot start replication yet.');
						return false;
					}

					self.syncHandler = self.db.sync(self.remote, {
						timeout: 0,
						conflicts: true,
						batch_size: 50,
						batches_limit: 1,
						live: true,
						retry: true // @TODO change - use ConnectionService to start/cancel replication
					});

					$log.debug('Starting replication for user db...', self.syncHandler);

					self.syncHandler
						.on('error', onError)
						.on('complete', onComplete)
						.on('paused', onPaused)
						.on('active', onActive)
						.on('denied', onDenied);

					systemPouch.startReplication();

					return true;
				})
				.catch(function(error) {

					cancelReplication();

                    systemPouch.cancelReplication();

					$log.error("Error getting an active session with the remote.", error);

					if (error.status === 401){
						return $q.reject();
					}
				});
		}

        /**
		 * @return Promise
         */
		function cancelReplication(){
			if (! lodash.isEmpty(self.syncHandler)){
				$log.debug('Cancelling replication / synchronization of user db...');

				return $q.when(self.syncHandler.cancel());
			}
			return $q.when(false);
		}

		function noActiveUser(){
			$log.warn('No Active User! Rejecting...');
			return $q.reject();
		}

		function redirectToLogin(){
			$log.warn('Not authorized. Sending to login...');
			$mdToast.show(
				$mdToast.simple()
					.content('Please login.')
					.position("top right")
					.hideDelay(0)
			);
			Utils.go('login');
		}

		function assertActiveUser(){
			return LocalUsers.activeUserName()
				.catch(noActiveUser);
		}

		function changePassword(password){

			return LocalUsers.activeUserName().then(function(userName){

				$log.debug('Changing password for username', userName);

				return self.remote.changePassword(userName, password);

			});
		}

		function getActiveUser(){
			return LocalUsers.activeUser();
		}

		function getActiveUserName(){
			return LocalUsers.activeUserName();
		}

		function allUsers(){
			return LocalUsers.all();
		}

		function localUserDatabase(){
			return LocalUsers.getDatabase();
		}

        /**
		 *
         * @private
		 * @return Promise
         */
		function _destroyUserDb(){
			if (self.db){
                $log.debug('Destroying userPouch db...');

                return self.db.destroy().catch(function(err){
                    $log.debug('Error destroying userPouch db', err);
                });
			}

			return $q.when(false);
		}

        /**
		 * @return Promise
         */
		function destroy(){
            return _destroyUserDb().then(LocalUsers.destroy);
		}

        /**
		 * @return Promise
         */
		function hasActiveSession(){
            return LocalUsers.activeUserName()
				.then(setupUserRemote)
				.then(function(){
					$log.debug('Checking if user has a valid session...');
                    return self.remote.getSession();
				});
		}

		// exposed, public API
		return {
			destroy: destroy,
			allUsers: allUsers,
            localUserDatabase: localUserDatabase,
			remote: getRemoteDatabase,
			db: getLocalDatabase,
			getActiveUser: getActiveUser,
            getActiveUserName: getActiveUserName,
			assertActiveUserAndBootstrap: assertActiveUserAndBootstrap,
			bootstrap: bootstrap,
			getSyncHandler: getSyncHandler,
			save: save,
			login: login,
			remove: remove,
			cancelReplication: cancelReplication,
			startReplication: startReplication,
			changePassword: changePassword,
			hasActiveSession: hasActiveSession,
            createCustomFieldIndex: createCustomFieldIndex
		};

	}

})();
